<template>
  <div class="app-container">
    <el-card class="mb10">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="" class="numberSearch">
              <template slot="label">
                <el-select v-model="type1" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <!-- 运单号 -->
                  <el-option :label="$t('GlobalSetObj.waybillNumber')" value="waybillNumbers" />
                  <!-- 业务单号 -->
                  <el-option :label="$t('receivablePayable.TicketNumber')" value="packageNumbers" />
                  <!-- 发票号码 -->
                  <!--<el-option :label="$t('basicData.InvoiceNumber')" value="invoiceNumberList" />-->
                </el-select>
              </template>
              <InputTextareaCmp
                ref="inputTextareaRef"
                :val="listVal"
                :max-length="2000"
                :min-rows="5"
                @input="(_, val) => listVal = val"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-row :gutter="10">
              <el-col :span="12">
                <!-- 操作时间 -->
                <el-form-item :label="$t('GlobalSetObj.operationTime')">
                  <el-date-picker
                    v-model="queryForm.params.invoiceIssueTime"
                    type="datetimerange"
                    range-separator="-"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('GlobalSetObj.startDate')"
                    :end-placeholder="$t('GlobalSetObj.endDate')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 业务类型 -->
                <el-form-item :label="$t('collectionCenter.businessT')">
                  <el-select
                    v-model="queryForm.params.businessTypes"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    multiple
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 操作类型 -->
                <el-form-item :label="$t('collectionCenter.operationType')">
                  <el-select
                    v-model="queryForm.params.operationTypes"
                    :placeholder="$t('collectionCenter.tudo')"
                    multiple
                    collapse-tags
                    clearable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in OPERATION_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--  客户  -->
                <el-form-item :label="$t('GlobalSetObj.client')">
                  <el-select
                    v-model="queryForm.params.customerIds"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    :remote-method="getCustomerPage"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    multiple
                    collapse-tags
                    style="width: 100%"
                    @visible-change="getCustomerPage()"
                  >
                    <el-option
                      v-for="item in customerList"
                      :key="item.id"
                      :label="item.customerAlias + '（' + item.username + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 操作人账号 -->
                <el-form-item :label="$t('mdfeTranslate.OperatorAccount')">
                  <el-select
                    v-model="queryForm.params.createUser"
                    :placeholder="$t('collectionCenter.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    remote
                    reserve-keyword
                    :remote-method="getAllUser"
                    @visible-change="getAllUserChange"
                  >
                    <el-option
                      v-for="(item, idx) in allUserList"
                      :key="idx"
                      :label="item.realName + '（' + item.username + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <div style="margin-top: 28px;">
                  <!--查询-->
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="small"
                    @click="search"
                  >{{ $t('basicData.Search') }}
                  </el-button>
                  <!--重置-->
                  <el-button
                    icon="el-icon-refresh"
                    size="small"
                    @click="onReset"
                  >{{ $t('basicData.reset') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div class="mb10">
        <!--导出-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:cteOperationLog-export'"
          size="small" type="primary" @click="onExport"
        >{{ $t('CenterForSorting.export') }}</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <!-- 操作时间 -->
        <el-table-column prop="operateTime" :label="$t('GlobalSetObj.operationTime')" min-width="180" />
        <!-- 操作类型 -->
        <el-table-column prop="operationTypeName" :label="$t('collectionCenter.operationType')" min-width="160" />
        <!-- 操作人账号 -->
        <el-table-column prop="operatorName" :label="$t('mdfeTranslate.OperatorAccount')" min-width="160" />
        <!-- 业务类型 -->
        <el-table-column prop="businessTypeName" :label="$t('collectionCenter.businessT')" min-width="160" />
        <!-- 客户名称 -->
        <el-table-column prop="customerName" :label="$t('basicData.CustomerName')" min-width="160" />
        <!-- 业务单号 -->
        <el-table-column prop="packageNumber" :label="$t('receivablePayable.TicketNumber')" min-width="220" />
        <!-- 运单号 -->
        <el-table-column prop="waybillNumber" :label="$t('GlobalSetObj.waybillNumber')" min-width="220" />
        <!-- 操作结果 -->
        <el-table-column prop="statusName" :label="$t('mdfeTranslate.OperationResult')" min-width="160" />
        <!-- 失败原因 -->
        <el-table-column prop="failCause" :label="$t('GlobalSetObj.ReasonForFailure')" min-width="160" />
        <!-- 请求参数 -->
        <el-table-column
          prop="requestData"
          :label="$t('mdfeTranslate.RequestParameters')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.requestData }}
              </pre>
              <div class="paramsStyle">{{ scope.row.requestData }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 响应结果 -->
        <el-table-column
          prop="responseData"
          :label="$t('collectionCenter.responseResult')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.responseData }}
              </pre>
              <div class="paramsStyle">{{ scope.row.responseData }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';
import {
  INVOICE_STATUS,
  BUSINESS_TYPE,
  OPERATION_TYPE
} from './utils';
import { copyData } from '@/utils/copyData';
import {
  getOperateLogExport,
  getOperateLogPage
} from '@/api/invoiceCenter';
import { apiCustomerPage } from '@/api/customer';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
import { getUserPage } from '@/api/user';

export default {
  name: 'CteOperationLog',

  components: {
    InputTextareaCmp
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      BUSINESS_TYPE, // 业务类型
      INVOICE_STATUS, // 发票状态
      OPERATION_TYPE, // 操作类型
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          invoiceIssueTime: [startTime, endTime],
          customerIds: [],
          businessTypes: [],
          packageNumbers: [],
          waybillNumbers: [],
          operationTypes: [],
          createUser: null
        }
      },
      type1: 'waybillNumbers',
      listVal: '',
      total: 0,
      tableData: [],
      pickerMinDate: '',
      pickerRange: 30 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      customerList: [],
      allUserList: []
    };
  },
  created() {
    this.getCustomerPage();
    setTimeout(() => {
      this.getTable();
    }, 100);
  },

  methods: {
    // 获取操作人
    getAllUser(name = '') {
      const query = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          accountState: '',
          realName: name
        }
      };
      getUserPage(query, false).then((res) => {
        if (res.code === 200) {
          this.allUserList = res.data.records;
        }
      });
    },
    // 打开操作人选项弹窗
    getAllUserChange(val) {
      if (val) {
        this.getAllUser();
      }
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 获取查询参数
    getQurey() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      const { type1 } = this;
      const { invoiceIssueTime, businessTypes, customerIds, operationTypes, createUser } = this.queryForm.params;
      const obj = {
        startTime: '',
        endTime: '',
        packageNumbers: [],
        waybillNumbers: [],
        customerIds,
        businessTypes,
        operationTypes,
        createUser
      };
      if (inputVal.length > 0) {
        obj[type1] = inputVal;
      }
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        obj.startTime = invoiceIssueTime[0];
        obj.endTime = invoiceIssueTime[1];
      }
      return obj;
    },
    // 获取列表数据
    getTable() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      if ((!inputVal || inputVal.length === 0) && (!this.queryForm.params.invoiceIssueTime || this.queryForm.params.invoiceIssueTime.length === 0)) {
        this.$message({
          message: this.$t('collectionCenter.PleaseSelectTime'), // 请选择日期时间
          type: 'warning'
        });
        return;
      }
      if (inputVal.length > 2000) {
        this.$message({
          message: this.$t('orderCenterCont.queried2000pieces'), // 超过2000个字符
          type: 'warning'
        });
        return;
      }
      const obj = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.getQurey()
      };
      getOperateLogPage(obj).then(res => {
        const { records, total } = res.data;
        this.total = total;
        records.map(item => {
          if (item.requestData) {
            try {
              const requestData = JSON.parse(item.requestData);
              item.requestData = JSON.stringify(requestData, null, 2);
            } catch {
              console.log(item.requestData);
            }
          }
          if (item.responseData) {
            try {
              const responseData = JSON.parse(item.responseData);
              item.responseData = JSON.stringify(responseData, null, 2);
            } catch {
              console.log(item.responseData);
            }
          }
        });
        this.tableData = records;
      }).catch(err => {
        console.error(err);
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTable();
    },
    // 重置
    onReset() {
      this.type1 = 'waybillNumbers';
      this.listVal = '';
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.queryForm.params = {
        invoiceIssueTime: [startTime, endTime],
        customerIds: [],
        businessTypes: [],
        packageNumbers: [],
        waybillNumbers: [],
        operationTypes: [],
        createUser: null
      };
      this.getTable();
    },
    // 导出
    onExport() {
      if (this.tableData.length > 0) {
        const params = this.getQurey();
        getOperateLogExport(params).then(() => {
          goResourceTaskList();
        }).catch(err => {
          console.error(err);
        });
      } else {
        this.$message.warning(this.$t('operationCenter.noDataExported'));
      }
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>

<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
